<div *ngIf="loading" class="d-flex justify-content-center align-items-center" style="margin-top:70px">
    <mat-spinner></mat-spinner>
</div>

<div>
    <app-status-no-data [show]="!loading && !data"></app-status-no-data>
</div>
<div class="row" *ngIf="!loading && data && data.length > 0">
    <div class="accordion accordion-flush" id="accordionFlushExample">
        <div class="accordion-item" *ngFor="let data of data; let i = index">
            <button
                    class="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    [attr.data-bs-target]="'#flush-collapse' + i"
                    [attr.aria-controls]="'flush-collapse' + i"
                    [attr.aria-expanded]="false">
                {{ data.school_program_name }}
                <fa-icon
                        [icon]="faEdit"
                        size="xs"
                        class="m-1"
                        (click)="onOpenModelEditModal(i); $event.stopPropagation()" *ngIf="auth.permissions['SCHOOL_PROGRAM_EDIT']">
                </fa-icon>
                <fa-icon
                        [icon]="faDelete"
                        size="xs"
                        class="m-1"
                        (click)="deleteSchoolProgram(i); $event.stopPropagation()" *ngIf="auth.permissions['SCHOOL_PROGRAM_DELETE']">
                </fa-icon>
            </button>
            <div
                    [id]="'flush-collapse' + i"
                    class="accordion-collapse collapse"
                    [attr.data-bs-parent]="'#accordionFlushExample'">
                <div class="accordion-body">

                    <div class="fs-17 mb-4">
                        {{data.school_program_description}}
                    </div>
                    <ngx-datatable *ngIf="data.categories?.length > 0"
                        [rows]="data.categories"
                        [count]="data.categories?.length"
                        [externalPaging]="true"
                        [externalSorting]="true"
                        [footerHeight]="50"
                        [headerHeight]="50"
                        [rowHeight]="40"
                        [scrollbarV]="true"
                        [scrollbarH]="true"
                        [selectAllRowsOnPage]="false"
                        class="ngx-datatable material expandable col-md-12"
                        columnMode="standard">
                        <ngx-datatable-column
                                [width]="300"
                                [canAutoResize]="true"
                                name="{{'CATEGORY_NAME' | translate}}"
                                prop="category_name"
                                [sortable]="true"
                        >
                            <ng-template let-row="row" ngx-datatable-cell-template>
                                <input
                                        *ngIf="isEditing(row, 'category_name')"
                                        [(ngModel)]="row.category_name"
                                        (blur)="onEditComplete(row)"
                                        (keydown.enter)="onEditComplete(row)"
                                        class="form-control input-cat"
                                        disabled="!auth.permissions['SCHOOL_PROGRAM_CATEGORY_EDIT']"
                                        type="text" style="width:100%; height:50%" />
                                <span *ngIf="!isEditing(row, 'category_name') && auth.permissions['SCHOOL_PROGRAM_CATEGORY_EDIT']" (click)="startEdit(row, 'category_name')">
                                {{ row.category_name || '-' }}
                              </span>
                                <span *ngIf="!isEditing(row, 'category_name') && !auth.permissions['SCHOOL_PROGRAM_CATEGORY_EDIT']">
                                {{ row.category_name || '-' }}
                              </span>
                            </ng-template>
                        </ngx-datatable-column>
                        <ngx-datatable-column
                                [width]="650"
                                [canAutoResize]="true"
                                name="{{'DESCRIPTION' | translate}}"
                                prop="category_description"
                                [sortable]="true">
                            <ng-template let-row="row" ngx-datatable-cell-template>
                                <input
                                        *ngIf="isEditing(row, 'category_description')"
                                        [(ngModel)]="row.category_description"
                                        (blur)="onEditComplete(row)"
                                        class="form-control input-desc"
                                        (keydown.enter)="onEditComplete(row)"
                                        disabled="!auth.permissions['SCHOOL_PROGRAM_CATEGORY_EDIT']"
                                        type="text"  style="width:100%; height:50%"/>
                                <span *ngIf="!isEditing(row, 'category_description') && auth.permissions['SCHOOL_PROGRAM_CATEGORY_EDIT']" (click)="startEdit(row, 'category_description')">
                                {{ row.category_description || '-' }}
                              </span>
                                <span *ngIf="!isEditing(row, 'category_description') && !auth.permissions['SCHOOL_PROGRAM_CATEGORY_EDIT']">
                                {{ row.category_description || '-' }}
                              </span>
                            </ng-template>
                        </ngx-datatable-column>
                        <ngx-datatable-column
                                [width]="120"
                                [canAutoResize]="true"
                                name="{{'ACTION' | translate}}">
                            <ng-template let-row="row" ngx-datatable-cell-template>
                                <div class="button-container">
                                    <button (click)="delete(row)" class="action-btn action-btn-delete" *ngIf="auth.permissions['SCHOOL_PROGRAM_CATEGORY_DELETE']">
                                        {{ 'REMOVE' | translate }}
                                    </button>
                                </div>
                            </ng-template>
                        </ngx-datatable-column>
                    </ngx-datatable>
                </div>
            </div>
        </div>
    </div>
</div>
<ng-template #updateSchoolProgram let-modal let-close="close">
    <form #programForm (ngSubmit)="editSchoolProgram()" [formGroup]="currentData">
        <div class="modal-header">
            <div class="row">
                <div class="col-md-12">
                    <h5 class="modal-title">{{ 'ADD_SCHOOL_PROGRAM' | translate }}</h5>
                </div>
            </div>
        </div>
        <ng-container>
            <div class="modal-body">
                <div class="">
                    <div class="d-grid" style="max-width: 600px;">
                        <span style="font-size: 14px; font-weight: bold; color: #333;">{{ 'SCHOOL_PROGRAM_NAME' | translate }}</span>
                        <input placeholder="{{ 'SCHOOL_PROGRAM_NAME_PLACEHOLDER' | translate }}"
                               class="form-control p-3 fs-14 border-1 rounded h-25 w-100"
                               style="outline: none;" formControlName="school_program_name">
                    </div>
                    <div class="d-grid">
                        <span style="font-size: 14px; font-weight: bold; color: #333;">{{ 'SCHOOL_PROGRAM_DESCRIPTION' | translate }}</span>
                        <textarea class="form-control" rows="3" placeholder="{{ 'SCHOOL_PROGRAM_DESCRIPTION_PLACEHOLDER' | translate }}" formControlName="school_program_description"></textarea>
                    </div>

                    <div class="d-flex justify-content-end align-items-end">
                        <button type="submit" [disabled]="disableFormSubmit" class="gradient-button col-md-2 mt-3 me-1">{{ 'SAVE' | translate }}</button>
                    </div>
                </div>
            </div>
        </ng-container>

    </form>
</ng-template>
